const electionData = [
  {
    province: 'EC',
    muni_code: 'EC124',
    municipality: 'Amahlathi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '73.06%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.32%',
    voter_difference: '-6.68%',
  },
  {
    province: 'EC',
    muni_code: 'EC102',
    municipality: 'Blue Crane Route',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '56.37%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.70%',
    voter_difference: '-8.30%',
  },
  {
    province: 'EC',
    muni_code: 'BUF',
    municipality: 'Buffalo City',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '59.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '59.43%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.24%',
    voter_difference: '-10.76%',
  },
  {
    province: 'EC',
    muni_code: 'EC101',
    municipality: 'Dr Beyers Naud\u00e9',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '51.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '46.82%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '47.04%',
    voter_difference: '-13.96%',
  },
  {
    province: 'EC',
    muni_code: 'EC141',
    municipality: 'Elundini',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '84.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '80.47%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.04%',
    voter_difference: '-6.96%',
  },
  {
    province: 'EC',
    muni_code: 'EC136',
    municipality: 'Emalahleni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '81.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '80.63%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.50%',
    voter_difference: '-7.50%',
  },
  {
    province: 'EC',
    muni_code: 'EC137',
    municipality: 'Engcobo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '83.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '82.00%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.96%',
    voter_difference: '-5.04%',
  },
  {
    province: 'EC',
    muni_code: 'EC139',
    municipality: 'Enoch Mgijima',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '72.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '62.17%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.11%',
    voter_difference: '-6.89%',
  },
  {
    province: 'EC',
    muni_code: 'EC123',
    municipality: 'Great Kei',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '65.62%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '55.65%',
    voter_difference: '-6.35%',
  },
  {
    province: 'EC',
    muni_code: 'EC153',
    municipality: 'Ingquza Hill',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '84.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '71.43%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.39%',
    voter_difference: '-6.61%',
  },
  {
    province: 'EC',
    muni_code: 'EC135',
    municipality: 'Intsika Yethu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '80.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '78.60%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.09%',
    voter_difference: '-8.91%',
  },
  {
    province: 'EC',
    muni_code: 'EC131',
    municipality: 'Inxuba Yethemba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.04%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.01%',
    voter_difference: '-7.99%',
  },
  {
    province: 'EC',
    muni_code: 'EC157',
    municipality: 'King Sabata Dalindyebo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '63.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '45.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.26%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '39.53%',
    voter_difference: '-5.47%',
  },
  {
    province: 'EC',
    muni_code: 'EC109',
    municipality: 'Kou Kamma',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '51.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '46.35%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.38%',
    voter_difference: '-7.62%',
  },
  {
    province: 'EC',
    muni_code: 'EC108',
    municipality: 'Kouga',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '53.50%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '57.08%',
    voter_difference: '-8.92%',
  },
  {
    province: 'EC',
    muni_code: 'EC104',
    municipality: 'Makana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.65%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.18%',
    voter_difference: '-7.82%',
  },
  {
    province: 'EC',
    muni_code: 'EC441',
    municipality: 'Matatiele',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '74.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.96%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.57%',
    voter_difference: '-6.43%',
  },
  {
    province: 'EC',
    muni_code: 'EC121',
    municipality: 'Mbhashe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '69.02%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.30%',
    voter_difference: '-7.70%',
  },
  {
    province: 'EC',
    muni_code: 'EC156',
    municipality: 'Mhlontlo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '77.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '74.70%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.26%',
    voter_difference: '-6.74%',
  },
  {
    province: 'EC',
    muni_code: 'EC122',
    municipality: 'Mnquma',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '74.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '70.29%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.46%',
    voter_difference: '-8.54%',
  },
  {
    province: 'EC',
    muni_code: 'EC105',
    municipality: 'Ndlambe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.61%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '55.16%',
    voter_difference: '-9.84%',
  },
  {
    province: 'EC',
    muni_code: 'NMA',
    municipality: 'Nelson Mandela Bay',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '47.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '39.43%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '45.88%',
    voter_difference: '-18.12%',
  },
  {
    province: 'EC',
    muni_code: 'EC126',
    municipality: 'Ngqushwa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '83.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '77.93%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.58%',
    voter_difference: '-4.42%',
  },
  {
    province: 'EC',
    muni_code: 'EC444',
    municipality: 'Ntabankulu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '85.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '81.21%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.15%',
    voter_difference: '-5.85%',
  },
  {
    province: 'EC',
    muni_code: 'EC155',
    municipality: 'Nyandeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '83.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '78.79%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.59%',
    voter_difference: '-8.41%',
  },
  {
    province: 'EC',
    muni_code: 'EC154',
    municipality: 'Port St Johns',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '79.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '73.77%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '51.45%',
    voter_difference: '-4.55%',
  },
  {
    province: 'EC',
    muni_code: 'EC129',
    municipality: 'Raymond Mhlaba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '78.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.73%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.30%',
    voter_difference: '-6.70%',
  },
  {
    province: 'EC',
    muni_code: 'EC138',
    municipality: 'Sakhisizwe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '80.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '70.09%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.00%',
    voter_difference: '-6.00%',
  },
  {
    province: 'EC',
    muni_code: 'EC142',
    municipality: 'Senqu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '73.23%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.20%',
    voter_difference: '-11.80%',
  },
  {
    province: 'EC',
    muni_code: 'EC106',
    municipality: 'Sundays River Valley',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '72.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '63.52%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.27%',
    voter_difference: '-11.73%',
  },
  {
    province: 'EC',
    muni_code: 'EC442',
    municipality: 'Umzimvubu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '77.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '76.84%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.91%',
    voter_difference: '-7.09%',
  },
  {
    province: 'EC',
    muni_code: 'EC145',
    municipality: 'Walter Sisulu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.56%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.30%',
    voter_difference: '-9.70%',
  },
  {
    province: 'EC',
    muni_code: 'EC443',
    municipality: 'Winnie Madikizela_Mandela',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '81.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '74.08%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.72%',
    voter_difference: '-10.28%',
  },
  {
    province: 'FS',
    muni_code: 'FS192',
    municipality: 'Dihlabeng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.69%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.82%',
    voter_difference: '-9.18%',
  },
  {
    province: 'FS',
    muni_code: 'FS162',
    municipality: 'Kopanong',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '70.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '66.04%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.33%',
    voter_difference: '-12.67%',
  },
  {
    province: 'FS',
    muni_code: 'FS161',
    municipality: 'Letsemeng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '69.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.53%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.82%',
    voter_difference: '-9.18%',
  },
  {
    province: 'FS',
    muni_code: 'FS205',
    municipality: 'Mafube',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '56.98%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.99%',
    voter_difference: '-9.01%',
  },
  {
    province: 'FS',
    muni_code: 'FS194',
    municipality: 'Maluti a Phofung',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '68.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '39.20%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '46.31%',
    voter_difference: '-6.69%',
  },
  {
    province: 'FS',
    muni_code: 'MAN',
    municipality: 'Mangaung',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.63%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.52%',
    voter_difference: '-14.48%',
  },
  {
    province: 'FS',
    muni_code: 'FS196',
    municipality: 'Mantsopa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '59.59%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.43%',
    voter_difference: '-8.57%',
  },
  {
    province: 'FS',
    muni_code: 'FS181',
    municipality: 'Masilonyana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '54.82%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.64%',
    voter_difference: '-13.36%',
  },
  {
    province: 'FS',
    muni_code: 'FS184',
    municipality: 'Matjhabeng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '63.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.48%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.61%',
    voter_difference: '-10.39%',
  },
  {
    province: 'FS',
    muni_code: 'FS204',
    municipality: 'Metsimaholo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '34.47%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '46.34%',
    voter_difference: '-11.66%',
  },
  {
    province: 'FS',
    muni_code: 'FS163',
    municipality: 'Mohokare',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.49%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.24%',
    voter_difference: '-4.76%',
  },
  {
    province: 'FS',
    muni_code: 'FS201',
    municipality: 'Moqhaka',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '49.55%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '42.52%',
    voter_difference: '-10.48%',
  },
  {
    province: 'FS',
    muni_code: 'FS185',
    municipality: 'Nala',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '48.72%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '46.95%',
    voter_difference: '-9.05%',
  },
  {
    province: 'FS',
    muni_code: 'FS203',
    municipality: 'Ngwathe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.66%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.85%',
    voter_difference: '-13.15%',
  },
  {
    province: 'FS',
    muni_code: 'FS193',
    municipality: 'Nketoana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.98%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.75%',
    voter_difference: '-7.25%',
  },
  {
    province: 'FS',
    muni_code: 'FS195',
    municipality: 'Phumelela',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '77.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.19%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.99%',
    voter_difference: '-13.01%',
  },
  {
    province: 'FS',
    muni_code: 'FS191',
    municipality: 'Setsoto',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.96%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.81%',
    voter_difference: '-9.19%',
  },
  {
    province: 'FS',
    muni_code: 'FS182',
    municipality: 'Tokologo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '56.84%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '55.85%',
    voter_difference: '-7.15%',
  },
  {
    province: 'FS',
    muni_code: 'FS183',
    municipality: 'Tswelopele',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.60%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.99%',
    voter_difference: '-14.01%',
  },
  {
    province: 'GP',
    muni_code: 'EKU',
    municipality: 'City of Ekurhuleni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '38.19%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '43.43%',
    voter_difference: '-14.57%',
  },
  {
    province: 'GP',
    muni_code: 'JHB',
    municipality: 'City of Johannesburg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'DA coalition then ANC coaltion',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '33.67%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '42.46%',
    voter_difference: '-14.54%',
  },
  {
    province: 'GP',
    muni_code: 'TSH',
    municipality: 'City of Tshwane',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '43.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '34.63%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '44.93%',
    voter_difference: '-14.07%',
  },
  {
    province: 'GP',
    muni_code: 'GT421',
    municipality: 'Emfuleni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '39.71%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '44.31%',
    voter_difference: '-10.69%',
  },
  {
    province: 'GP',
    muni_code: 'GT423',
    municipality: 'Lesedi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.43%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.11%',
    voter_difference: '-12.89%',
  },
  {
    province: 'GP',
    muni_code: 'GT484',
    municipality: 'Merafong City',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '48.97%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '42.02%',
    voter_difference: '-11.98%',
  },
  {
    province: 'GP',
    muni_code: 'GT422',
    municipality: 'Midvaal',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '62.69%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '54.06%',
    voter_difference: '-11.94%',
  },
  {
    province: 'GP',
    muni_code: 'GT481',
    municipality: 'Mogale City',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '40.17%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.49%',
    voter_difference: '-13.51%',
  },
  {
    province: 'GP',
    muni_code: 'GT485',
    municipality: 'Rand West City',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '53.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '45.33%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '42.66%',
    voter_difference: '-14.34%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN263',
    municipality: 'Abaqulusi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '47.00%',
    '2016_council _run_by': 'IFP coalition/hung council',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '31.10%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '47.59%',
    voter_difference: '-8.41%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN238',
    municipality: 'Alfred Duma',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '63.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '37.84%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '53.59%',
    voter_difference: '-8.41%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN276',
    municipality: 'Big 5 Hlabisa',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '52.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'IFP',
    '2021_perc_of_votes_cast_for_winning_party': '55.60%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '56.74%',
    voter_difference: '-7.26%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN254',
    municipality: 'Dannhauser',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '34.97%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.40%',
    voter_difference: '-10.60%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN436',
    municipality: 'Dr Nkosasana Dlamini Zumu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '78.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.79%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '55.72%',
    voter_difference: '-10.28%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN261',
    municipality: 'eDumbe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '51.00%',
    '2016_council _run_by': 'ANC/IFP coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '23.53%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '57.84%',
    voter_difference: '-3.16%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN253',
    municipality: 'eMadlangeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '29.04%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.33%',
    voter_difference: '-9.67%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN241',
    municipality: 'Endumeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '50.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '36.18%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '49.88%',
    voter_difference: '-9.12%',
  },
  {
    province: 'KZN',
    muni_code: 'ETH',
    municipality: 'eThekwini',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '42.02%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '42.04%',
    voter_difference: '-17.96%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN433',
    municipality: 'Greater Kokstad',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '59.37%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.69%',
    voter_difference: '-6.31%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN224',
    municipality: 'Impendle',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '89.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '69.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '58.30%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '56.33%',
    voter_difference: '-12.67%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN237',
    municipality: 'Inkosi Langalibalele (Estcourt/Loskop)',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '35.25%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '55.52%',
    voter_difference: '-10.48%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN272',
    municipality: 'Jozini',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '48.00%',
    '2016_council _run_by': 'IFP coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '35.19%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '60.09%',
    voter_difference: '-3.91%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN292',
    municipality: 'KwaDukuza',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '49.56%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '53.42%',
    voter_difference: '-13.58%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN291',
    municipality: 'Mandeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.11%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.84%',
    voter_difference: '-15.16%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN294',
    municipality: 'Maphumulo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '46.85%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.52%',
    voter_difference: '-8.48%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN281',
    municipality: 'Mfolozi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '50.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '37.29%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '53.32%',
    voter_difference: '-11.68%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN226',
    municipality: 'Mkhambathini',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '63.69%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '40.26%',
    voter_difference: '-23.74%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN223',
    municipality: 'Mpofana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '65.71%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.73%',
    voter_difference: '-14.27%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN244',
    municipality: 'Msinga',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'IFP',
    '2021_perc_of_votes_cast_for_winning_party': '67.02%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '57.51%',
    voter_difference: '-9.49%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN225',
    municipality: 'Msunduzi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '48.32%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '47.96%',
    voter_difference: '-19.04%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN285',
    municipality: 'Mthonjaneni',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '37.89%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.33%',
    voter_difference: '-11.67%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN275',
    municipality: 'Mtubatuba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'IFP coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '35.97%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '57.41%',
    voter_difference: '-4.59%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN293',
    municipality: 'Ndwedwe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '72.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.22%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '54.51%',
    voter_difference: '-10.49%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN252',
    municipality: 'Newcastle',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '31.30%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '45.91%',
    voter_difference: '-13.09%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN286',
    municipality: 'Nkandla',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'IFP',
    '2021_perc_of_votes_cast_for_winning_party': '57.10%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '56.01%',
    voter_difference: '-9.99%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN265',
    municipality: 'Nongoma',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '53.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '16.92%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.73%',
    voter_difference: '-6.27%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN242',
    municipality: 'Nquthu',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'IFP coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '36.15%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '53.42%',
    voter_difference: '-4.58%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN235',
    municipality: 'Okhahlamba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '29.32%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.87%',
    voter_difference: '-5.13%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN216',
    municipality: 'Ray Nkonyeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.78%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.81%',
    voter_difference: '',
  },
  {
    province: 'KZN',
    muni_code: 'KZN227',
    municipality: 'Richmond',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '77.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '69.76%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.43%',
    voter_difference: '-9.57%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN434',
    municipality: 'Ubuhlebezwe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '63.04%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '53.16%',
    voter_difference: '-10.84%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN266',
    municipality: 'Ulundi',
    party_with_the_most_votes_in_2016: 'IFP',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'IFP',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '11.19%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '50.31%',
    voter_difference: '-8.69%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN212',
    municipality: 'Umdoni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '44.15%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.35%',
    voter_difference: '-11.65%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN271',
    municipality: 'Umhlabuyalingana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '45.64%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '57.81%',
    voter_difference: '-6.19%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN282',
    municipality: 'uMhlathuze',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '39.50%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '44.04%',
    voter_difference: '-15.96%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN284',
    municipality: 'uMlalazi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'IFP',
    '2021_perc_of_votes_cast_for_winning_party': '53.46%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '49.71%',
    voter_difference: '-13.29%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN222',
    municipality: 'uMngeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '68.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '47.41%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '57.11%',
    voter_difference: '-10.89%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN221',
    municipality: 'uMshwathi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '68.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '58.86%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '53.17%',
    voter_difference: '-14.83%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN214',
    municipality: 'UMuziwabantu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '42.27%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.28%',
    voter_difference: '-7.72%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN245',
    municipality: 'Umvoti',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '36.13%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '56.43%',
    voter_difference: '-8.57%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN435',
    municipality: 'Umzimkhulu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '86.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '74.18%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.92%',
    voter_difference: '-9.08%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN213',
    municipality: 'Umzumbe',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '75.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.29%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.78%',
    voter_difference: '-6.22%',
  },
  {
    province: 'KZN',
    muni_code: 'KZN262',
    municipality: 'UPhongolo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '33.90%',
    '2021_council_run_by': 'IFP',
    '2021_voter_turnout': '54.93%',
    voter_difference: '-4.07%',
  },
  {
    province: 'LP',
    muni_code: 'LIM334',
    municipality: 'Ba-Phalaborwa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '68.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.15%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.51%',
    voter_difference: '-7.49%',
  },
  {
    province: 'LP',
    muni_code: 'LIM366',
    municipality: 'Bela-Bela',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '53.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.82%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.15%',
    voter_difference: '-4.85%',
  },
  {
    province: 'LP',
    muni_code: 'LIM351',
    municipality: 'Blouberg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '74.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.97%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.89%',
    voter_difference: '-6.11%',
  },
  {
    province: 'LP',
    muni_code: 'LIM345',
    municipality: 'Collins Chabane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '85.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '45.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '75.36%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.43%',
    voter_difference: '2.43%',
  },
  {
    province: 'LP',
    muni_code: 'LIM472',
    municipality: 'Elias Motsoaledi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '58.02%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '39.70%',
    voter_difference: '-12.30%',
  },
  {
    province: 'LP',
    muni_code: 'LIM471',
    municipality: 'Ephraim Mogale',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.08%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.36%',
    voter_difference: '-5.64%',
  },
  {
    province: 'LP',
    muni_code: 'LIM476',
    municipality: 'Fetakgomo Tubatse',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '69.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '68.18%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '41.24%',
    voter_difference: '-8.76%',
  },
  {
    province: 'LP',
    muni_code: 'LIM331',
    municipality: 'Greater Giyani',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '82.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '74.71%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.75%',
    voter_difference: '-6.25%',
  },
  {
    province: 'LP',
    muni_code: 'LIM332',
    municipality: 'Greater Letaba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '77.46%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.54%',
    voter_difference: '-1.46%',
  },
  {
    province: 'LP',
    muni_code: 'LIM333',
    municipality: 'Greater Tzaneen',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '75.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.08%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.74%',
    voter_difference: '-8.26%',
  },
  {
    province: 'LP',
    muni_code: 'LIM355',
    municipality: 'Lepele-Nkumpi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '63.66%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.30%',
    voter_difference: '-6.70%',
  },
  {
    province: 'LP',
    muni_code: 'LIM362',
    municipality: 'Lephalale',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.02%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.13%',
    voter_difference: '-2.87%',
  },
  {
    province: 'LP',
    muni_code: 'LIM344',
    municipality: 'Makhado',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '75.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '46.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '79.86%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.77%',
    voter_difference: '-3.23%',
  },
  {
    province: 'LP',
    muni_code: 'LIM473',
    municipality: 'Makhuduthamaga',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '68.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '62.76%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '38.90%',
    voter_difference: '-11.10%',
  },
  {
    province: 'LP',
    muni_code: 'LIM335',
    municipality: 'Maruleng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '54.46%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '58.28%',
    voter_difference: '2.28%',
  },
  {
    province: 'LP',
    muni_code: 'LIM368',
    municipality: 'Modimolle/Mookgopong',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '48.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '49.83%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '49.84%',
    voter_difference: '-8.16%',
  },
  {
    province: 'LP',
    muni_code: 'LIM367',
    municipality: 'Mogalakwena',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '49.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.35%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '41.14%',
    voter_difference: '-7.86%',
  },
  {
    province: 'LP',
    muni_code: 'LIM353',
    municipality: 'Molemole',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '73.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '68.19%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '46.16%',
    voter_difference: '-5.84%',
  },
  {
    province: 'LP',
    muni_code: 'LIM341',
    municipality: 'Musina',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '75.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.85%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.75%',
    voter_difference: '-6.25%',
  },
  {
    province: 'LP',
    muni_code: 'LIM354',
    municipality: 'Polokwane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.08%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.52%',
    voter_difference: '-8.48%',
  },
  {
    province: 'LP',
    muni_code: 'LIM361',
    municipality: 'Thabazimbi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by':
      "ANC coalition with Thabazimbi Resident's Council mayor",
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '47.40%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '41.30%',
    voter_difference: '-9.70%',
  },
  {
    province: 'LP',
    muni_code: 'LIM343',
    municipality: 'Thulamela',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '79.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '46.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '85.18%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '40.84%',
    voter_difference: '-5.16%',
  },
  {
    province: 'MP',
    muni_code: 'MP325',
    municipality: 'Bushbuckridge',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '70.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '65.81%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.20%',
    voter_difference: '-10.80%',
  },
  {
    province: 'MP',
    muni_code: 'MP301',
    municipality: 'Chief Albert Luthuli',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '84.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '76.06%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.66%',
    voter_difference: '-15.34%',
  },
  {
    province: 'MP',
    muni_code: 'MP306',
    municipality: 'Dipaleseng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '57.78%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.99%',
    voter_difference: '-14.01%',
  },
  {
    province: 'MP',
    muni_code: 'MP316',
    municipality: 'Dr JS Moroka',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '69.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '59.68%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.92%',
    voter_difference: '-12.08%',
  },
  {
    province: 'MP',
    muni_code: 'MP304',
    municipality: 'Dr Pixley Ka Isaka Seme',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '78.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.70%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.11%',
    voter_difference: '-13.89%',
  },
  {
    province: 'MP',
    muni_code: 'MP314',
    municipality: 'Emakhazeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '70.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '63.91%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.71%',
    voter_difference: '-8.29%',
  },
  {
    province: 'MP',
    muni_code: 'MP312',
    municipality: 'Emalahleni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.58%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '39.49%',
    voter_difference: '-11.51%',
  },
  {
    province: 'MP',
    muni_code: 'MP307',
    municipality: 'Govan Mbeki',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '41.08%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '40.69%',
    voter_difference: '-13.31%',
  },
  {
    province: 'MP',
    muni_code: 'MP305',
    municipality: 'Lekwa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '68.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '42.03%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '45.97%',
    voter_difference: '-11.03%',
  },
  {
    province: 'MP',
    muni_code: 'MP326',
    municipality: 'Mbombela',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '65.21%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '41.14%',
    voter_difference: '-18.86%',
  },
  {
    province: 'MP',
    muni_code: 'MP303',
    municipality: 'Mkhondo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '77.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.98%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.60%',
    voter_difference: '-13.40%',
  },
  {
    province: 'MP',
    muni_code: 'MP302',
    municipality: 'Msukaligwa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '75.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.00%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '40.84%',
    voter_difference: '-16.16%',
  },
  {
    province: 'MP',
    muni_code: 'MP324',
    municipality: 'Nkomazi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '83.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '72.75%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '45.23%',
    voter_difference: '-15.77%',
  },
  {
    province: 'MP',
    muni_code: 'MP313',
    municipality: 'Steve Tshwete',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '36.85%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '44.43%',
    voter_difference: '-8.57%',
  },
  {
    province: 'MP',
    muni_code: 'MP321',
    municipality: 'Thaba Chweu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '54.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '58.33%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.51%',
    voter_difference: '-10.49%',
  },
  {
    province: 'MP',
    muni_code: 'MP315',
    municipality: 'Thembisile Hani',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '76.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.63%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '40.78%',
    voter_difference: '-14.22%',
  },
  {
    province: 'MP',
    muni_code: 'MP311',
    municipality: 'Victor Khanye',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.31%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.10%',
    voter_difference: '-2.90%',
  },
  {
    province: 'NC',
    muni_code: 'NC084',
    municipality: '!Kheis',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '57.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '76.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '46.44%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '70.69%',
    voter_difference: '-5.31%',
  },
  {
    province: 'NC',
    muni_code: 'NC087',
    municipality: 'Dawid Kruiper',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '59.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.14%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '54.13%',
    voter_difference: '-10.87%',
  },
  {
    province: 'NC',
    muni_code: 'NC092',
    municipality: 'Dikgatlong',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.07%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '56.73%',
    voter_difference: '-4.27%',
  },
  {
    province: 'NC',
    muni_code: 'NC073',
    municipality: 'Emthanjeni',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '58.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.31%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.99%',
    voter_difference: '-12.01%',
  },
  {
    province: 'NC',
    muni_code: 'NC452',
    municipality: 'Ga-Segonyana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.46%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '43.50%',
    voter_difference: '-13.50%',
  },
  {
    province: 'NC',
    muni_code: 'NC453',
    municipality: 'Gamagara',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '41.97%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '50.60%',
    voter_difference: '-6.40%',
  },
  {
    province: 'NC',
    muni_code: 'NC065',
    municipality: 'Hantam',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '44.53%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '60.96%',
    voter_difference: '-5.04%',
  },
  {
    province: 'NC',
    muni_code: 'NC451',
    municipality: 'Joe Morolong',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.21%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '51.35%',
    voter_difference: '-3.65%',
  },
  {
    province: 'NC',
    muni_code: 'NC082',
    municipality: 'Kai !Garib',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '58.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '63.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '44.36%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '60.21%',
    voter_difference: '-2.79%',
  },
  {
    province: 'NC',
    muni_code: 'NC064',
    municipality: 'Kamiesberg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '63.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '68.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.45%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '69.63%',
    voter_difference: '1.63%',
  },
  {
    province: 'NC',
    muni_code: 'NC074',
    municipality: 'Kareeberg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '47.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '44.17%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '65.61%',
    voter_difference: '-0.39%',
  },
  {
    province: 'NC',
    muni_code: 'NC066',
    municipality: 'Karoo Hoogland',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '40.84%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '62.13%',
    voter_difference: '0.13%',
  },
  {
    province: 'NC',
    muni_code: 'NC086',
    municipality: 'Kgatelopele',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '43.69%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.17%',
    voter_difference: '-10.83%',
  },
  {
    province: 'NC',
    muni_code: 'NC067',
    municipality: 'Khai-Ma',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '58.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.55%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '55.72%',
    voter_difference: '-2.28%',
  },
  {
    province: 'NC',
    muni_code: 'NC093',
    municipality: 'Magareng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.34%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '53.24%',
    voter_difference: '-5.76%',
  },
  {
    province: 'NC',
    muni_code: 'NC062',
    municipality: 'Nama Khoi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '47.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '42.01%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.27%',
    voter_difference: '-3.73%',
  },
  {
    province: 'NC',
    muni_code: 'NC094',
    municipality: 'Phokwane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '47.17%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.61%',
    voter_difference: '-8.39%',
  },
  {
    province: 'NC',
    muni_code: 'NC075',
    municipality: 'Renosterberg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '52.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '70.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.01%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '68.00%',
    voter_difference: '-2.00%',
  },
  {
    province: 'NC',
    muni_code: 'NC061',
    municipality: 'Richtersveld',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '53.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '47.29%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '60.39%',
    voter_difference: '0.39%',
  },
  {
    province: 'NC',
    muni_code: 'NC078',
    municipality: 'Siyancuma',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '58.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '52.12%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '53.69%',
    voter_difference: '-10.31%',
  },
  {
    province: 'NC',
    muni_code: 'NC077',
    municipality: 'Siyathemba',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '44.40%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '59.90%',
    voter_difference: '-5.10%',
  },
  {
    province: 'NC',
    muni_code: 'NC091',
    municipality: 'Sol Plaatje',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '58.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.16%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.98%',
    voter_difference: '-11.02%',
  },
  {
    province: 'NC',
    muni_code: 'NC076',
    municipality: 'Thembelihle',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '39.81%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '59.01%',
    voter_difference: '-5.99%',
  },
  {
    province: 'NC',
    muni_code: 'NC085',
    municipality: 'Tsantsabane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '50.42%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '50.00%',
    voter_difference: '-14.00%',
  },
  {
    province: 'NC',
    muni_code: 'NC071',
    municipality: 'Ubuntu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '43.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.50%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '60.45%',
    voter_difference: '-6.55%',
  },
  {
    province: 'NC',
    muni_code: 'NC072',
    municipality: 'Umsobomvu',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '68.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '68.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.83%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '63.34%',
    voter_difference: '-4.66%',
  },
  {
    province: 'NW',
    muni_code: 'NW384',
    municipality: 'Ditsobotla',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.58%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.90%',
    voter_difference: '-6.10%',
  },
  {
    province: 'NW',
    muni_code: 'NW394',
    municipality: 'Greater Taung',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '57.22%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.86%',
    voter_difference: '-8.14%',
  },
  {
    province: 'NW',
    muni_code: 'NW405',
    municipality: 'JB Marks',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '51.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '48.00%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '46.09%',
    voter_difference: '-11.91%',
  },
  {
    province: 'NW',
    muni_code: 'NW397',
    municipality: 'Kagisano-Molopo',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '74.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '66.77%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.85%',
    voter_difference: '-9.15%',
  },
  {
    province: 'NW',
    muni_code: 'NW374',
    municipality: 'Kgetlengrivier',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '56.10%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '49.05%',
    voter_difference: '-10.95%',
  },
  {
    province: 'NW',
    muni_code: 'NW396',
    municipality: 'Lekwa-Teemane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '63.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '48.17%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.36%',
    voter_difference: '-10.64%',
  },
  {
    province: 'NW',
    muni_code: 'NW372',
    municipality: 'Madibeng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.16%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '41.18%',
    voter_difference: '-11.82%',
  },
  {
    province: 'NW',
    muni_code: 'NW383',
    municipality: 'Mahikeng',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '56.57%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '38.05%',
    voter_difference: '-11.95%',
  },
  {
    province: 'NW',
    muni_code: 'NW393',
    municipality: 'Mamusa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '59.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '55.99%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '52.26%',
    voter_difference: '-6.74%',
  },
  {
    province: 'NW',
    muni_code: 'NW404',
    municipality: 'Maquassi Hills',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '57.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '60.65%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '47.68%',
    voter_difference: '-9.32%',
  },
  {
    province: 'NW',
    muni_code: 'NW403',
    municipality: 'Matlosana',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '58.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '51.94%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.77%',
    voter_difference: '-15.23%',
  },
  {
    province: 'NW',
    muni_code: 'NW371',
    municipality: 'Moretele',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '71.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.64%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.23%',
    voter_difference: '-8.77%',
  },
  {
    province: 'NW',
    muni_code: 'NW375',
    municipality: 'Moses Kotane',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.36%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '41.28%',
    voter_difference: '-10.72%',
  },
  {
    province: 'NW',
    muni_code: 'NW392',
    municipality: 'Naledi',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '56.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '53.82%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '44.43%',
    voter_difference: '-11.57%',
  },
  {
    province: 'NW',
    muni_code: 'NW385',
    municipality: 'Ramotshere Moiloa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '60.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '61.23%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '48.30%',
    voter_difference: '-4.70%',
  },
  {
    province: 'NW',
    muni_code: 'NW381',
    municipality: 'Ratlou',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '69.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '53.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '67.82%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.81%',
    voter_difference: '-10.19%',
  },
  {
    province: 'NW',
    muni_code: 'NW373',
    municipality: 'Rustenburg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '48.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '50.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '46.74%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '36.33%',
    voter_difference: '-13.67%',
  },
  {
    province: 'NW',
    muni_code: 'NW382',
    municipality: 'Tswaing',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '51.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '64.95%',
    '2021_council_run_by': 'ANC',
    '2021_voter_turnout': '42.84%',
    voter_difference: '-8.16%',
  },
  {
    province: 'WC',
    muni_code: 'WC053',
    municipality: 'Beaufort West',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'DA coalition. then ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '28.31%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '57.47%',
    voter_difference: '-3.53%',
  },
  {
    province: 'WC',
    muni_code: 'WC013',
    municipality: 'Bergrivier',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '64.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '62.10%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '54.61%',
    voter_difference: '-7.39%',
  },
  {
    province: 'WC',
    muni_code: 'WC047',
    municipality: 'Bitou',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '49.00%',
    '2016_council _run_by': 'ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '68.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '40.36%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '64.31%',
    voter_difference: '-3.69%',
  },
  {
    province: 'WC',
    muni_code: 'WC025',
    municipality: 'Breede Valley',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '48.06%',
    voter_difference: '-11.94%',
  },
  {
    province: 'WC',
    muni_code: 'WC033',
    municipality: 'Cape Agulhas',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '54.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '44.04%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '56.91%',
    voter_difference: '-10.09%',
  },
  {
    province: 'WC',
    muni_code: 'WC012',
    municipality: 'Cederberg',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '35.45%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '54.84%',
    voter_difference: '-7.16%',
  },
  {
    province: 'WC',
    muni_code: 'CPT',
    municipality: 'City of Cape Town',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '67.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '18.63%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '47.68%',
    voter_difference: '-16.32%',
  },
  {
    province: 'WC',
    muni_code: 'WC023',
    municipality: 'Drakenstein',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '66.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '65.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '55.41%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '51.13%',
    voter_difference: '-13.87%',
  },
  {
    province: 'WC',
    muni_code: 'WC044',
    municipality: 'George',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '61.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '46.44%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.59%',
    voter_difference: '-9.41%',
  },
  {
    province: 'WC',
    muni_code: 'WC042',
    municipality: 'Hessequa',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '45.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '71.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '50.19%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '62.95%',
    voter_difference: '-8.05%',
  },
  {
    province: 'WC',
    muni_code: 'WC041',
    municipality: 'Kannaland',
    party_with_the_most_votes_in_2016: 'ICOSA',
    '2016_perc_of_votes_cast_for_winning_party': '48.00%',
    '2016_council _run_by': 'Icosa/ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '70.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '21.52%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '60.89%',
    voter_difference: '-9.11%',
  },
  {
    province: 'WC',
    muni_code: 'WC048',
    municipality: 'Knysna',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '50.00%',
    '2016_council _run_by': 'DA coalition. then ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '35.44%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '55.79%',
    voter_difference: '-8.21%',
  },
  {
    province: 'WC',
    muni_code: 'WC051',
    municipality: 'Laingsburg',
    party_with_the_most_votes_in_2016: 'ANC',
    '2016_perc_of_votes_cast_for_winning_party': '46.00%',
    '2016_council _run_by': 'DA coaltion. then ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '71.00%',
    party_with_the_most_votes_in_2021: 'ANC',
    '2021_perc_of_votes_cast_for_winning_party': '26.25%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '68.50%',
    voter_difference: '-2.50%',
  },
  {
    province: 'WC',
    muni_code: 'WC026',
    municipality: 'Langeberg',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '51.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '43.37%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '47.30%',
    voter_difference: '-11.70%',
  },
  {
    province: 'WC',
    muni_code: 'WC011',
    municipality: 'Matzikama',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '55.00%',
    '2016_council _run_by': 'ANC',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '60.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '37.30%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '53.87%',
    voter_difference: '-6.13%',
  },
  {
    province: 'WC',
    muni_code: 'WC043',
    municipality: 'Mossel Bay',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '61.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '66.24%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '55.29%',
    voter_difference: '-8.71%',
  },
  {
    province: 'WC',
    muni_code: 'WC045',
    municipality: 'Oudtshoorn',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '56.00%',
    '2016_council _run_by': 'DA. then ANC coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '55.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '30.06%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '44.29%',
    voter_difference: '-10.71%',
  },
  {
    province: 'WC',
    muni_code: 'WC032',
    municipality: 'Overstrand',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '65.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '67.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '63.69%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '58.14%',
    voter_difference: '-8.86%',
  },
  {
    province: 'WC',
    muni_code: 'WC052',
    municipality: 'Prince Albert',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '34.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '76.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '37.44%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '70.74%',
    voter_difference: '-5.26%',
  },
  {
    province: 'WC',
    muni_code: 'WC014',
    municipality: 'Saldanha Bay',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '62.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '64.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '46.34%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '51.09%',
    voter_difference: '-12.91%',
  },
  {
    province: 'WC',
    muni_code: 'WC024',
    municipality: 'Stellenbosch',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '69.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '62.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '61.43%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '46.06%',
    voter_difference: '-15.94%',
  },
  {
    province: 'WC',
    muni_code: 'WC015',
    municipality: 'Swartland',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '70.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '59.76%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '47.46%',
    voter_difference: '-11.54%',
  },
  {
    province: 'WC',
    muni_code: 'WC034',
    municipality: 'Swellendam',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '48.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '66.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '52.22%',
    '2021_council_run_by': 'DA',
    '2021_voter_turnout': '58.90%',
    voter_difference: '-7.10%',
  },
  {
    province: 'WC',
    muni_code: 'WC031',
    municipality: 'Theewaterskloof',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '52.00%',
    '2016_council _run_by': 'DA',
    '2016_coalitions': 'No',
    '2016_voter_turnout': '59.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '41.67%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '43.63%',
    voter_difference: '-15.37%',
  },
  {
    province: 'WC',
    muni_code: 'WC022',
    municipality: 'Witzenberg',
    party_with_the_most_votes_in_2016: 'DA',
    '2016_perc_of_votes_cast_for_winning_party': '46.00%',
    '2016_council _run_by': 'DA coalition',
    '2016_coalitions': 'Yes',
    '2016_voter_turnout': '52.00%',
    party_with_the_most_votes_in_2021: 'DA',
    '2021_perc_of_votes_cast_for_winning_party': '36.64%',
    '2021_council_run_by': 'hung',
    '2021_voter_turnout': '43.38%',
    voter_difference: '-8.62%',
  },
]

export { electionData }
